import React, { useState } from 'react';
import { useSelector } from 'store';

import ImageSlider from 'components/common/ImageSlider';
import Modal from 'components/common/Modal';
import Head from 'next/head';
import styled from 'styled-components';
import ModalRetailMap from './components/ModalRetailMap';

const RetailDetailService: React.FC = () => {
  const retail = useSelector(state => state.space.retail);
  const { branch } = retail.floor;
  const { features } = retail;

  const [isHoverOnMapIcon, setIsHoverOnMap] = useState(false);

  const kakao = branch.map_url_kakao;
  const google = branch.map_url_google;
  const naver = branch.map_url_naver;

  const { openModal, closeModal, ModalPortal } = Modal();

  return (
    <>
      <Head>
        <title>{`로컬스티치 - ${retail.name}`}</title>
        <meta name="application-name" content={`로컬스티치 - ${retail.name}`} />
        <meta
          name="msapplication-tooltip"
          content={`로컬스티치 - ${retail.name}`}
        />
        <meta
          id="meta_og_title"
          property="og:title"
          content={`로컬스티치 - ${retail.name}`}
        />
      </Head>
      <div className="cnts-wrap">
        <div className="retail-detail">
          <div className="hgroup">
            <span
              className="logo"
              style={{ backgroundImage: `url(${retail.representation_image})` }}
            />
            <h2>{retail.name}</h2>
            <address>{branch.address}</address>
            <div
              className="btn-map"
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <OpenMapModalButton
                onClick={openModal}
                onPointerEnter={() => setIsHoverOnMap(true)}
                onPointerLeave={() => setIsHoverOnMap(false)}
              >
                <img
                  src={
                    isHoverOnMapIcon
                      ? '/images/map-gray.svg'
                      : '/images/map.svg'
                  }
                  alt=""
                  style={{ width: 28, height: 28 }}
                />
                <span
                  style={{
                    color: isHoverOnMapIcon ? '#808080' : '#111',
                    marginLeft: 8,
                  }}
                >
                  지도 보기
                </span>
              </OpenMapModalButton>
              <div>
                <span>
                  <OpenMapPageAnchor
                    href={kakao}
                    target="_blank"
                    rel="noreferrer"
                  >
                    카카오
                  </OpenMapPageAnchor>
                </span>
                <span style={{ margin: 6 }}>·</span>
                <span>
                  <OpenMapPageAnchor
                    href={google}
                    target="_blank"
                    rel="noreferrer"
                  >
                    구글
                  </OpenMapPageAnchor>
                </span>
                <span style={{ margin: 6 }}>·</span>
                <span>
                  <OpenMapPageAnchor
                    href={naver}
                    target="_blank"
                    rel="noreferrer"
                  >
                    네이버
                  </OpenMapPageAnchor>
                </span>
              </div>
            </div>
          </div>
          {retail.images.length ? <ImageSlider images={retail.images} /> : null}
          <div className="detail-cnts">
            <p style={{ whiteSpace: 'pre-line' }}>{retail.introduction}</p>
          </div>
          <div className="retail-info">
            <h3>{retail.name}에서는</h3>
            <ul>
              {features.map((feature, index) => (
                <li key={index}>{feature.description}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <ModalPortal>
        <ModalRetailMap closeModal={closeModal} branch={branch} />
      </ModalPortal>
    </>
  );
};

const OpenMapModalButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-right: 8px;
  padding-right: 8px;
  border-right: 1px solid #111;
`;

const OpenMapPageAnchor = styled.a`
  :hover {
    color: #808080;
  }
`;

export default RetailDetailService;
